import { Model, Collection } from 'vue-mc';

export class ClientModel extends Model {
	defaults() {
		return {
			id: null,
			name: null,
			surnames: null,
			email: null,
			phone: null,
			dni: null,
			all_consum_groups: [],
			consumption_group_id: null,
			consumption_group_manage: 0,
			consumption_group_name: null,
			weekly_minimum_baskets: null,
			free_shipping_minimum_baskets: null,
			addresses_list: [
				{
					name: null,
					address_type: 2,
					main_address: 1,
					cp: null,
					address: null,
					city_id: null,
				},
			],
			balance: {
				wallet: 0,
				contribution: 0,
				required_balance: 0,
			},
			consumption_baskets: 0,
			city_id: null,
			address: null,
			cp: null,
			customer_type_id: null,
			password: null,
			password_confirmation: null,
			local_coin: 0,
			policy: true,
			newsletter: false,
			activated: 0,
		};
	}
}

class ClientList extends Collection {
	model() {
		return ClientModel;
	}
}
